import apiClient from './authService';

export const referenceCodeTypeService = {
  // Get all reference code types by type
  getReferenceCodeTypes: async (type) => {
    const response = await apiClient.get(`/reference-code-types/${type}`);
    return response.data;
  },

  // Get all active industry types
  getAllActiveIndustryTypes: async () => {
    return await referenceCodeTypeService.getReferenceCodeTypes('industryType');
  },

  // Get all customer status types
  getAllCustomerStatusTypes: async () => {
    return await referenceCodeTypeService.getReferenceCodeTypes('customerStatus');
  },

  // Get all campaign types
  getAllCampaignTypes: async () => {
    return await referenceCodeTypeService.getReferenceCodeTypes('campaignType');
  },

  // Get all message types
  getAllMessageTypes: async () => {
    return await referenceCodeTypeService.getReferenceCodeTypes('messageType');
  },

  // Get all message event types
  getAllMessageEventTypes: async () => {
    return await referenceCodeTypeService.getReferenceCodeTypes('messageEventType');
  },

  // Get all template category types
  getAllTemplateCategoryTypes: async () => {
    return await referenceCodeTypeService.getReferenceCodeTypes('templateCategoryType');
  },

  // Get all message direction types
  getAllMessageDirectionTypes: async () => {
    return await referenceCodeTypeService.getReferenceCodeTypes('messageDirectionType');
  },

  // Get all message status types
  getAllMessageStatusTypes: async () => {
    return await referenceCodeTypeService.getReferenceCodeTypes('messageStatusType');
  },

  // Get all template status types
  getAllTemplateStatusTypes: async () => {
    return await referenceCodeTypeService.getReferenceCodeTypes('templateStatusType');
  },

  // Get all campaign status types
  getAllCampaignStatusTypes: async () => {
    return await referenceCodeTypeService.getReferenceCodeTypes('campaignStatusType');
  },

  // Get all flow status types
  getAllFlowStatusTypes: async () => {
    return await referenceCodeTypeService.getReferenceCodeTypes('flowStatus');
  },

  // Get all flow category types
  getAllFlowCategoryTypes: async () => {
    return await referenceCodeTypeService.getReferenceCodeTypes('flowCategory');
  },

  // Generic method to get a specific reference code type by code
  getReferenceCodeType: async (type, codeType) => {
    const allTypes = await referenceCodeTypeService.getReferenceCodeTypes(type);
    return allTypes.find(item => item.codeType === codeType);
  }
};
